import React, { type FC } from 'react'

import classes from './ArticleInfo.module.scss'

type ArticleInfoProps = {
  title: string
}

export const ArticleInfo: FC<ArticleInfoProps> = ({ title }) => {
  return <div className={classes.Title}>{title}</div>
}
